<template>
  <section class="ficha -practica">

    <template v-if="!!data.oferta">

      <h2 class="ficha-title" :style="styles.colorBasic">Información del puesto</h2>

      <article class="group">

        <h3 class="group-title" :style="styles.colorBasic">Puesto</h3>

        <div class="contenedor-data" v-if="!!data.oferta.fechaAlta">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de Alta</h4>
          <p>{{data.oferta.fechaAlta}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.curso">
          <h4 class="data-title" :style="styles.colorBasic">Curso académico</h4>
          <p>{{data.oferta.curso}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.puesto">
          <h4 class="data-title" :style="styles.colorBasic">Nombre de la oferta</h4>
          <p>{{data.oferta.puesto}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.numeroPlazas">
          <h4 class="data-title" :style="styles.colorBasic">Número de plazas</h4>
          <p>{{data.oferta.numeroPlazas}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.areaFuncional">
          <h4 class="data-title" :style="styles.colorBasic">Área funcional</h4>
          <p>{{data.oferta.areaFuncional}}</p>
        </div>

        <div class="contenedor-data -full" v-if="!!data.oferta.descripcionPuesto">
          <h4 class="data-title" :style="styles.colorBasic">Descripción del puesto</h4>
          <p>{{data.oferta.descripcionPuesto}}</p>
        </div>
      </article>


      <article class="group">
        <h3 class="group-title" :style="styles.colorBasic">Duración</h3>
        <div class="contenedor-data" v-if="data.oferta.horasAlDia != ''">
          <h4 class="data-title" :style="styles.colorBasic">Horas al día</h4>
          <p>{{data.oferta.horasAlDia}}</p>
        </div>
        <div class="contenedor-data" v-if="!!data.oferta.diasDeLaSemana">
          <h4 class="data-title" :style="styles.colorBasic">Días a la semana</h4>
          <p>{{data.oferta.diasDeLaSemana}}</p>
        </div>
        <div class="contenedor-data" v-if="!!data.oferta.horario">
          <h4 class="data-title" :style="styles.colorBasic">Días a la semana</h4>
          <p>{{data.oferta.horario}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.fechaInicio">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de inicio</h4>
          <p>{{data.oferta.fechaInicio}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.fechaFin">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de fin</h4>
          <p>{{data.oferta.fechaFin}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.horasTotales">
          <h4 class="data-title" :style="styles.colorBasic">Horas totales</h4>
          <p>{{data.oferta.horasTotales}}</p>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">Horarios especiales o periodos no lectivos</h4>
          <p>{{(data.oferta.horariosEspeciales) ? 'Sí' : 'No'}}</p>
        </div>

      </article>

      <article class="group">
        <h3 class="group-title" :style="styles.colorBasic">Localización</h3>

        <div class="contenedor-data" v-if="!!data.oferta.centroTrabajo.nombre">
          <h4 class="data-title" :style="styles.colorBasic">Centro de trabajo</h4>
          <p>{{data.oferta.centroTrabajo.nombre}}</p>
        </div>


        <div class="contenedor-data" v-if="!!data.oferta.centroTrabajo.pais">
          <h4 class="data-title" :style="styles.colorBasic">País</h4>
          <p>{{data.oferta.centroTrabajo.pais}}</p>
        </div>


        <div class="contenedor-data" v-if="!!data.oferta.centroTrabajo.provincia">
          <h4 class="data-title" :style="styles.colorBasic">Provincia</h4>
          <p>{{data.oferta.centroTrabajo.provincia}}</p>
        </div>


        <div class="contenedor-data" v-if="!!data.oferta.centroTrabajo.poblacion">
          <h4 class="data-title" :style="styles.colorBasic">Población</h4>
          <p>{{data.oferta.centroTrabajo.poblacion}}</p>
        </div>


      </article>

      <article class="group">
        <h3 class="group-title" :style="styles.colorBasic">Detalles</h3>

        <div class="contenedor-data" v-if="!!data.oferta.centroTrabajo.ayudaAlEstudio">
          <h4 class="data-title" :style="styles.colorBasic">Remuneración</h4>
          <p>{{data.oferta.centroTrabajo.ayudaAlEstudio}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.otrasRemuneraciones">
          <h4 class="data-title" :style="styles.colorBasic">Otras remuneraciones</h4>
          <p>{{data.oferta.otrasRemuneraciones}}</p>
        </div>
      </article>

      <h2 class="ficha-title" :style="styles.colorBasic">Requisitos</h2>

      <article class="group">
        <div class="contenedor-data -full" v-if="!!data.oferta.titulacionConcreta">
          <h4 class="data-title" :style="styles.colorBasic">Titulación requerida</h4>
          <p>{{data.oferta.titulacionConcreta}}</p>
        </div>
        <div class="contenedor-data" v-if="data.oferta.curricular == true">
          <h4 class="data-title" :style="styles.colorBasic">Tipo créditos</h4>
          <p>Curricular</p>
        </div>
        <div class="contenedor-data" v-if="data.oferta.idiomas && dominios.idiomas">
          <h4 class="data-title" :style="styles.colorBasic">Idiomas</h4>
          <p v-for="idioma in data.oferta.idiomas">{{dominios.idiomas[idioma.idIdioma]}}
            <template v-if="idioma.idNivel&& dominios.nivelesIdioma">- {{dominios.nivelesIdioma[idioma.idNivel]}}</template>
            <template v-if="idioma.descripcionCertificacion">- {{idioma.descripcionCertificacion}}</template>
          </p>
        </div>

        <div class="contenedor-data" v-if="data.oferta.programasRequeridos">
          <h4 class="data-title" :style="styles.colorBasic">Programas informáticos</h4>
          <p v-for="programa in data.oferta.programasRequeridos">{{programa}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.requisitosObligatorios">
          <h4 class="data-title" :style="styles.colorBasic">Requisitos Obligatorios</h4>
          <p>{{data.oferta.requisitosObligatorios}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.requisitosDeseables">
          <h4 class="data-title" :style="styles.colorBasic">Requisitos Deseables</h4>
          <p>{{data.oferta.requisitosDeseables}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.motivosExlusion">
          <h4 class="data-title" :style="styles.colorBasic">Motivos de exclusión</h4>
          <p>{{data.oferta.motivosExlusion}}</p>
        </div>

        <div class="contenedor-data" v-if="data.oferta.documentosRequeridos.length != 0">
          <h4 class="data-title" :style="styles.colorBasic">Documentos requeridos</h4>
          <p v-for="documento in data.oferta.documentosRequeridos">{{documento.nombre}}</p>
        </div>

      </article>

      <h2 class="ficha-title" :style="styles.colorBasic">Empresa</h2>

      <article class="group">

        <h3 class="group-title" :style="styles.colorBasic">Datos de la empresa</h3>
        <div class="contenedor-data -full" v-if="!!data.empresa.nombreComercial">
          <h4 class="data-title" :style="styles.colorBasic">Nombre comercial</h4>
          <p>{{data.empresa.nombreComercial}}</p>
        </div>
        <div class="contenedor-data" v-if="!!data.empresa.cif">
          <h4 class="data-title" :style="styles.colorBasic">CIF</h4>
          <p>{{data.empresa.cif}}</p>
        </div>
        <div class="contenedor-data" v-if="!!data.empresa.sector">
          <h4 class="data-title" :style="styles.colorBasic">Sector</h4>
          <p>{{data.empresa.sector}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.empresa.direccion">
          <h4 class="data-title" :style="styles.colorBasic">Dirección</h4>
          <p>{{data.empresa.direccion}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.empresa.localidad">
          <h4 class="data-title" :style="styles.colorBasic">Localidad</h4>
          <p>{{data.empresa.localidad}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.empresa.provincia">
          <h4 class="data-title" :style="styles.colorBasic">Provincia</h4>
          <p>{{data.empresa.provincia}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.empresa.cp">
          <h4 class="data-title" :style="styles.colorBasic">Código postal</h4>
          <p>{{data.empresa.cp}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.empresa.paisDescripcion">
          <h4 class="data-title" :style="styles.colorBasic">País</h4>
          <p>{{data.empresa.paisDescripcion}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.empresa.web">
          <h4 class="data-title" :style="styles.colorBasic">Web</h4>
          <p><a :href="data.empresa.web" target="_blank">{{data.empresa.web}}</a></p>
        </div>
        <div class="contenedor-data" v-if="!!data.empresa.descripcion">
          <h4 class="data-title" :style="styles.colorBasic">Descripción</h4>
          <p>{{data.empresa.descripcion}}</p>
        </div>

      </article>

      <article class="group">
        <h3 class="group-title" :style="styles.colorBasic">Tutor de la empresa</h3>

        <div class="contenedor-data" v-if="!!data.oferta.nombreTutorEmpresa">
          <h4 class="data-title" :style="styles.colorBasic">Nombre del tutor de empresa</h4>
          <p>{{data.oferta.nombreTutorEmpresa}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.oferta.apellidosTutorEmpresa">
          <h4 class="data-title" :style="styles.colorBasic">Apellidos del tutor de empresa</h4>
          <p>{{data.oferta.apellidosTutorEmpresa}}</p>
        </div>

      </article>

      <article class="group">
        <h3 class="group-title" :style="styles.colorBasic">Contacto/s de la empresa</h3>
        <template v-for="(el,key) in data.contactos">
          <div class="contenedor-data" v-if="!!el.nombre">
            <h4 class="data-title" :style="styles.colorBasic">Nombre</h4>
            <p>{{el.nombre}}</p>
          </div>

          <div class="contenedor-data" v-if="!!el.apellidos">
            <h4 class="data-title" :style="styles.colorBasic">Apellidos</h4>
            <p>{{el.apellidos}}</p>
          </div>

          <div class="contenedor-data" v-if="!!el.puesto">
            <h4 class="data-title" :style="styles.colorBasic">Puesto</h4>
            <p>{{el.puesto}}</p>
          </div>

          <div class="contenedor-data" v-if="!!el.nombre">
            <h4 class="data-title" :style="styles.colorBasic">Teléfono</h4>
            <p><a :href="`tel:${el.telefono}`">{{el.telefono}}</a></p>
          </div>

          <div class="contenedor-data" v-if="!!el.nombre">
            <h4 class="data-title" :style="styles.colorBasic">Email</h4>
            <p><a :href="`mailto:${el.email}`">{{el.email}}</a></p>
          </div>



        </template>
      </article>
      <template v-if="!!!data.normativaConGestionExterna">
        <article class="group">
          <h3 class="group-title" :style="styles.colorBasic">Documentos modelo para Formalización</h3>
          <p class="explicacion">Estos documentos serán respectivamente el calendario que el/la estudiante deba
            cumplimentar semanalmente, y el modelo de Anexo 7.</p>

          <p class="explicacion">¡Atención! La práctica no podrá darse como validada hasta que no hayas aportado este
            modelo.</p>

          <div class="contenedor-data" v-if="!!data.oferta.urlPlantillaAnexo7">
            <h4 class="data-title" :style="styles.colorBasic">Modelo Anexo 7</h4>
            <arrow-link :text="'Ver Adjunto'" :external="true" :to="data.oferta.urlPlantillaAnexo7" :blank="true" v-if="data.oferta.urlPlantillaAnexo7"></arrow-link>
          </div>

          <div class="contenedor-data" v-if="!!data.oferta.urlPlantillaCalendario">
            <h4 class="data-title" :style="styles.colorBasic">Modelo Calendario</h4>
            <arrow-link :text="'Ver Adjunto'" :external="true" :to="data.oferta.urlPlantillaCalendario" :blank="true" v-if="data.oferta.urlPlantillaCalendario"></arrow-link>
          </div>
        </article>

        <adjunto :id="data.oferta.idOferta" @refresh="setData" :showplantilla="data.oferta.urlPlantillaAnexo7" :showcalendario="data.oferta.urlPlantillaCalendario" v-if="!!!data.oferta.urlPlantillaAnexo7 || !!!data.oferta.urlPlantillaCalendario"></adjunto>
      </template>
    </template>

    <loading v-else></loading>

  </section>
</template>

<script>

  import { mapGetters, mapActions } from 'vuex'

  import adjunto from '@/components/parts/adjunto-oferta-cf';

  import arrowlink from '@/components/parts/icons/arrow-link';

  import loading from '@/components/parts/loading';

  export default {
    mounted() {
      setTimeout(() => {
        this.setData();
      }, 1000);
    },
    data: () => ({
      data: {}
    }),
    methods: {
      ...mapActions(['dameOfertaDeCiclo']),
      setData() {

        let not = ['pendientes', 'tramitadas'];

        let id = (this.$route.params.id) ? this.$route.params.id : this.$route.params.status;

        if (!not.some(e => e == id) && id) {
          this.dameOfertaDeCiclo(id).then(r => {
            this.data = r;
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        colors: 'basicColors',
        dominios: 'getDominios'
      }),
    },
    components: {
      'adjunto': adjunto,
      'arrow-link': arrowlink,
      'loading': loading
    },
    watch: {
      '$route'() {
        this.setData();
      }
    }
  }


</script>


// WEBPACK FOOTER //
// src/components/views/ficha-oferta-cf.vue